var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},React.createElement("path",{"d":"M6.983 55.475h10.71V22.489H6.984v32.986zm11.063-42.16c0 2.833-2.185 5.127-5.779 5.127-3.381 0-5.566-2.294-5.566-5.126 0-2.9 2.255-5.127 5.707-5.127 3.453 0 5.568 2.226 5.638 5.127zM24.104 33.012c0-4.114-.14-7.554-.281-10.523h9.3l.494 4.587h.211c1.41-2.159 4.863-5.33 10.64-5.33 7.048 0 12.332 4.521 12.332 14.234v19.494H46.09v-18.28c0-4.25-1.551-7.15-5.427-7.15-2.96 0-4.72 1.957-5.496 3.845-.282.674-.353 1.619-.353 2.564v19.021h-10.71V33.012z"})));
}

Linkedin.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
